export const sexsTypes: any[] = [
    {value: 'F', viewValue: 'Femenino'},
    {value: 'M', viewValue: 'Masculino'},
    {value: 'O', viewValue: 'Otro'},
  ];